/**
 * 砍价插件主题初始化
 * 先判断商城是否激活了砍价主题
 * 已激活则判断用户是否登录，未登录跳转到微信登录界面
 */

export default function (window) {
  const isActive = isAcitve()
  if (isActive) {
    isRegisted(window)
    return true
  } else {
    return false
  }
}

/**
 * 获取当前url参数,判断是否安装了砍价插件
 */
function isAcitve () {
  let urlStr = window.location.search
  const num = urlStr.indexOf('kanjia')
  //  如果存在kanjia字段则插入砍价插件，开始砍价,不存在则不砍价
  if (num !== -1) {
    begainBargain()
    return true
  } else {
    return false
  }
}

/**
 * 对于参与砍价活动的商品判断是否登录
 * 未登录直接跳转到微信登录页面
 */
function isRegisted (window) {
  (function (yhsd) {
    return yhsd.ready(function (sdk) {
      return sdk
        .account
        .current(function (User) {
          if (!User.res.customer) {
            //  未登录，跳转到微信登录页
            linkWeChatLogin()
          }
        })
    })
  })(window.yhsd)
}

/**
 * 跳转到微信登录页
 */
function linkWeChatLogin () {
  const hostStr = encodeURIComponent(`${window.location.href}`)
  window.document.cookie = `redirect_back_url=${hostStr}; path=/`
  const linkWeChatLoginStr = `https://youhaosuda.com/api/auth?type=weixin&from=${hostStr}`
  window.location.href = linkWeChatLoginStr
}

/**
 * 替换body节点内容并将插件安装在插入的app节点下
 */
function begainBargain () {
  const body = document.querySelector('body')
  const bodyArray = Array.from(body.children)
  const firstChildBody = bodyArray[0]
  let divApp = document.createElement('div')
  divApp.setAttribute('id', 'kj-app')
  body.insertBefore(divApp, firstChildBody)
}



// WEBPACK FOOTER //
// ./src/common/util/theme.js